import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { mediaQueries } from '@blocket/blazar-plugins-device'
import { BlocketLogo, BlocketSymbol, Link, colors } from '@blocket/blocket-ui'

const LEFT_MARGIN_PX = 24

const SymbolWrapper = styled.div`
  display: block;
  a {
    display: flex;
  }
  @media ${mediaQueries.medium} {
    display: none;
  }
`

const LogoWrapper = styled.div`
  display: none;
  @media ${mediaQueries.medium} {
    display: block;
  }
`

const ResponsiveHeaderWrapper = styled.header`
  display: flex;
  justify-content: center;
  background-color: ${colors.white100};
  box-shadow: 0px 0px 3px rgba(54, 52, 51, 0.259398);
  height: 3.75rem;
  padding-left: 16px;
  padding-right: 16px;
`

const ContentWrapper = styled.div`
  display: flex;
  align-items: center;
  max-width: calc(980px + ${LEFT_MARGIN_PX}px);
  width: 100%;
`

const ResponsiveHeader = ({ children }) => (
  <ResponsiveHeaderWrapper>
    <ContentWrapper>
      <SymbolWrapper>
        <Link to="/">
          <BlocketSymbol width={40} />
        </Link>
      </SymbolWrapper>
      <LogoWrapper>
        <Link style={{ display: 'flex' }} to="/">
          <BlocketLogo width={120} />
        </Link>
      </LogoWrapper>
      {children}
    </ContentWrapper>
  </ResponsiveHeaderWrapper>
)

ResponsiveHeader.propTypes = {
  children: PropTypes.node,
}

export default ResponsiveHeader
